import { DdLogs } from "./datadog"

export const logger = store => next => action => {
    if (import.meta.env.DEV) {
      console.info('[Redux]', action.type)
    }
    const result = next(action)
    return result
  }
  
export const crashReporter = store => next => action => {
    try {
      return next(action)
    } catch (err) {
      DdLogs.error('Caught an exception!', {
        err: err,
        extra: {
          action,
          state: store.getState()
        }
      })
      throw err
    }
  }